import type {
  DataAuditDashboardCard,
  DataAuditWritebackDashboardCardApi,
  DataAuditWritebackType,
} from 'src/components/data-audit/types';

import type {LabelTranslationFn} from './label-types';


export function getDataAuditWritebackBreakdownCategoryLabel(
  writebackType: DataAuditWritebackType,
  t: LabelTranslationFn,
): string {
  const labelMap: Record<DataAuditWritebackType, string> = {
    nwb: t('Note', 'Note'),
    fwb: t('Field_Update', 'Field Update'),
    owb: t('Object_Create', 'Object Create'),
  };

  return labelMap[writebackType];
}

export function aggregateWritebackDashboardCards(
  cards: Array<DataAuditWritebackDashboardCardApi>,
): DataAuditDashboardCard {
  const totals = cards.reduce(
    (acc, card) => ({
      totalWritebacks: acc.totalWritebacks + card.totalWritebacks,
      successCount: acc.successCount + card.successCount,
      failureCount: acc.failureCount + card.failureCount,
      currentlyInQueue: acc.currentlyInQueue + card.currentlyInQueue,
    }),
    {
      totalWritebacks: 0,
      successCount: 0,
      failureCount: 0,
      currentlyInQueue: 0,
    },
  );

  const successRate =
    totals.totalWritebacks > 0
      ? Number(
          ((totals.successCount / totals.totalWritebacks) * 100).toFixed(2),
        )
      : 0;

  return {
    totalWritebacks: totals.totalWritebacks,
    successRate,
    failureCount: totals.failureCount,
    currentlyInQueue: totals.currentlyInQueue,
  };
}

export function normalizeDataAuditWritebackType(
  writebackType: string,
): DataAuditWritebackType {
  const normalized = writebackType.toLowerCase();

  if (normalized === 'nwb' || normalized === 'owb' || normalized === 'fwb') {
    return normalized;
  }

  return 'owb';
}

export function formatDataAuditWritebackTypeLabel(
  writebackType: string,
  t: LabelTranslationFn,
): string {
  return getDataAuditWritebackBreakdownCategoryLabel(
    normalizeDataAuditWritebackType(writebackType),
    t,
  );
}
